import axios from 'axios';
// config
import { HOST_BASE_URL } from '../config-global';
import { API_ENDPOINTS } from "src/api";

// ----------------------------------------------------------------------

let isRefreshing = false;
let refreshPromise = null;

console.log(process.env.REACT_APP_HOST_BASE_UR, HOST_BASE_URL);
const stbServer = axios.create({
  baseURL: HOST_BASE_URL,
});

export const stbWithoutAuth = axios.create({
  baseURL: HOST_BASE_URL,
});

// Authentication interceptors removed - no auth required for KYC flow
// unique_id will be passed as query parameter in API calls

export default stbServer;
